import React from 'react';
import { SketchPicker } from 'react-color';

import { makeStyles } from '@material-ui/core';
import { boxShadow } from 'html2canvas/dist/types/css/property-descriptors/box-shadow';

const useStyles = makeStyles(theme => styles(theme));

// https://casesandberg.github.io/react-color/ -> Documentation
function ColourPicker({ ...otherProps }) {
    const classes = useStyles();

    const presetColours = [
        '#9ED6DE',
        '#A9FE95',
        '#FFE5A0',
        '#FF7981',
        '#D6D6FF',
        '#DBE8EA',
        '#ff9e9e',
        '#ffcf9e'
    ];

    return (
        <SketchPicker
            presetColors={presetColours}
            disableAlpha
            className={classes.sketchChanges}
            {...otherProps}
        />
    );
}

const styles = (theme: any) => ({
    sketchChanges: {
        background: `${theme.palette.background.paper} !important`,
        width: '300px !important',
        padding: '10px 10px 0 !important',
        borderRadius: `${theme.typography.chip.borderRadius} !important`,
        boxShadow: 'none !important',
        '& label': {
            color: `${theme.palette.text.primary} !important`,
            fontFamily: `${theme.typography.fontFamily} !important`,
            padding: '7px 0 10px 0 !important',
            fontSize: 'unset !important'
        },
        '& input': {
            fontSize: 'unset !important',
            fontFamily: `${theme.typography.fontFamily} !important`,
            borderRadius: `${theme.typography.chip.borderRadius} !important`,
            backgroundColor: `${theme.palette.background.main}`,
            color: `${theme.palette.text.primary}`,
            textAlign: 'center'
        },
        '& span': {
            display: 'block',
            height: '20px',
            width: '20px',
            paddingLeft: '50px'
        }
    }
});

export default ColourPicker;
